<template>
  <div>
    <loader-component v-if="loader" />
    <div v-else>
      <v-toolbar flat color="white" class="mb-4">
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn @click="backToNews" class="primary">{{
          $t("button.newsBack")
        }}</v-btn>
      </v-toolbar>
      <form-wrapper :validator="$v.form">
        <v-card>
          <v-form @submit.prevent="save">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" class="mx-auto">
                  <locale-select
                    v-model="locale"
                    @change="handleChangeLocale"
                  />
                </v-col>

                <v-col cols="12">
                  <h2 class="mb-2 text-sm-center my-3">
                    {{ $t("headings.main_photo") }}
                  </h2>
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="imgPath"
                    @fileSelected="getImgValue"
                    :maxSize="mainMediaSize"
                    :imgId="main_photo && main_photo.id"
                  />
                  <p v-if="imgErorr" class="img_error">
                    {{ $t("validation.image_required") }}
                  </p>
                </v-col>
                <v-col cols="12">
                  <input-feild
                    v-model="form.title"
                    validateName="title"
                    :v="$v.form.title"
                    @activeSaveButton="handleActive"
                  ></input-feild>
                </v-col>
                <v-col cols="12">
                  <text-area-feild
                    v-model="form.desc"
                    validateName="desc"
                    :v="$v.form.desc"
                    @activeSaveButton="handleActive"
                    rows="10"
                  ></text-area-feild>
                </v-col>

                <v-col sm="6">
                  <input-feild
                    v-model="form.publisher"
                    validateName="publisher"
                    :v="$v.form.publisher"
                    @activeSaveButton="handleActive"
                  ></input-feild>
                </v-col>
                <v-col sm="6">
                  <input-feild
                    v-model="form.source"
                    validateName="source"
                    :v="$v.form.source"
                    @activeSaveButton="handleActive"
                  ></input-feild>
                </v-col>
                <v-col cols="12" sm="6">
                  <input-feild
                    v-model="form.source_url"
                    validateName="source_url"
                    :v="$v.form.source_url"
                    @activeSaveButton="handleActive"
                  ></input-feild>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    outlined
                    :label="$t('labels.tags')"
                    :items="tags"
                    item-text="name"
                    item-value="id"
                    v-model="form.tagesIds"
                    multiple
                    chips
                    @change="handleActive"
                  >
                  </v-select>
                </v-col>
                <!-- </v-col> -->
                <!-- rightSide -->
                <v-col cols="12">
                  <v-col cols="12">
                    <h2 class="text-md-center">
                      {{ $t("headings.photos") }}
                    </h2>
                    <input
                      type="file"
                      ref="file"
                      @change="onFileChange"
                      style="display:none"
                      multiple
                    />
                    <div class="text-sm-center mt-3 mb-3">
                      <v-btn class="primary" small @click="$refs.file.click()">
                        <span class="mx-2"> {{ $t("button.choose") }}</span>
                        <v-icon right dark>mdi-upload</v-icon>
                      </v-btn>
                    </div>
                    <v-row row wrap justify-center>
                      <v-col
                        cols="2"
                        v-for="(showImg, index) in ShowImgs"
                        :key="index"
                        class="mb-3 mx-2 img_pointer"
                      >
                        <v-img
                          aspect-ratio="1"
                          :src="showImg"
                          alt
                          class="ml-3"
                          style="border-radius:5px;box-shadow:0 4px 10px #444"
                        >
                        </v-img>
                        <v-icon
                          class="close_icon"
                          medium
                          color="#fff"
                          @click="deleteIamge($event, index, ShowImgs)"
                          >mdi-close</v-icon
                        >
                      </v-col>
                    </v-row>
                  </v-col>
                  <h2 class="text-md-center">
                    {{ $t("headings.videos") }}
                  </h2>
                  <v-col cols="12" md="6" class="mx-auto">
                    <form-group name="vedio">
                      <template slot-scope="{ attrs }">
                        <div class="input_wrpper">
                          <v-text-field
                            v-model="form.vedio"
                            v-bind="attrs"
                            @input="$v.form.vedio.$touch()"
                            @change="change = false"
                          ></v-text-field>
                          <v-btn
                            @click="addVedios('videos')"
                            :class="{ btn_left: hanldeDirrection }"
                            v-show="form.vedio !== ''"
                            class="btn"
                            color="primary"
                            :disabled="$v.form.vedio.$invalid"
                            >{{ $t("button.add") }}</v-btn
                          >
                          <v-row>
                            <v-col
                              v-for="(vedio, index) in form.vedios"
                              :key="index"
                              class="video_pointer mb-2"
                            >
                              <div v-if="form.vedios.length > 0">
                                <iframe
                                  class="ml-2"
                                  width="100%"
                                  height="200"
                                  :src="convertVedio(vedio)"
                                  frameborder="0"
                                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                  allowfullscreen
                                ></iframe>
                                <v-icon
                                  class="close_icon"
                                  medium
                                  color="#fff"
                                  @click="
                                    deleteVidoe($event, index, form.vedios)
                                  "
                                  >mdi-close
                                </v-icon>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </template>
                    </form-group>
                  </v-col>
                </v-col>
                <v-col cols="12" class="text-sm-right">
                  <v-btn
                    :disabled="dissabledButton()"
                    type="submit"
                    class="primary"
                    :loading="loading"
                  >
                    {{ saveButton }}</v-btn
                  ></v-col
                >
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </form-wrapper>
      <v-dialog v-model="errorDialog" max-width="300">
        <v-card>
          <v-card-text class="subheading">
            <h4>{{ errorText }}</h4>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="errorDialog = false" flat>Got it!</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { deleteMedia } from "@/api/media.js";
import { maxWords } from "@/utils/validate";

import {
  required,
  maxLength,
  minLength,
  url,
  requiredIf
} from "vuelidate/lib/validators";
import { storeNews, getTags, showNews, updateNews } from "@/api/news.js";
import Cookies from "js-cookie";

export default {
  name: "create_news",
  components: {
    InputFeild: () => import("@/components/InputFeild"),
    TextAreaFeild: () => import("@/components/TextAreaFeild")
  },

  validations() {
    if (!this.isUpdated) {
      return this.validationsRules();
    } else {
      return this.validationsRules();
    }
  },
  data() {
    return {
      isUpdated: false,
      form: {
        title: "",
        desc: "",
        publisher: "",
        imgValue: "",
        photo: "",
        vedio: "",
        vedios: [],
        source: "",
        source_url: "",
        tagesIds: []
      },
      ShowImgs: [],
      main_photo: {},
      imgsFiles: [],
      tags: [],
      imgErorr: false,
      change: true,
      imgPath: "",
      mainMediaSize: 2,
      photoSize: 1024,
      errorDialog: null,
      errorText: "",
      updatedData: {
        vedios: []
      },
      loading: false,
      loader: true,
      locale: this.locale,
      photosMedia: [],
      videosMedia: []
    };
  },
  computed: {
    LanguageDissabled() {
      if (this.$route.query.slug) {
        return false;
      } else {
        return true;
      }
    },
    formTitle() {
      return !this.isUpdated
        ? this.$t("headings.create")
        : this.$t("headings.edit");
    },
    saveButton() {
      return !this.isUpdated ? this.$t("button.save") : this.$t("button.edit");
    },
    sourceValidation() {
      return this.source_url !== null && this.source_url !== "";
    },
    hanldeDirrection() {
      let lang = Cookies.get("language");
      if (lang == "ar") {
        return true;
      } else {
        return false;
      }
    }
  },
  created() {
    this.getTags();
    if (this.$route.query && this.isUpdated) {
      this.showNews(this.$route.query.slug);
    }
  },

  methods: {
    handleChangeLocale(locale) {
      this.locale = locale;
      this.showNews(this.$route.query.slug, locale);
    },
    getTags() {
      getTags()
        .then(res => {
          const { data } = res.data;
          this.tags = [...data];
          this.loader = false;
        })
        .catch(() => {});
    },
    save() {
      this.loading = true;
      this.$v.$touch();
      !this.form.imgValue && !this.isUpdated ? (this.imgErorr = true) : "";
      if (!this.isUpdated && !this.$v.$error) {
        storeNews(this.formatingData())
          .then(() => {
            this.$router.push("/news/list");
            this.change = true;

            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        const { slug } = this.$route.query;
        updateNews(this.formatingData(), slug)
          .then(() => {
            // this.$store.dispatch("ChangeLocale", Cookies.get("language"));
            this.change = true;
            this.$router.push("/news/list");
            this.updatedData.vedios = [];
            // const { place } = res.data;
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    formatingData() {
      const formatData = new FormData();
      //   const items= this.form;
      //   for (const key in items) {
      //     formatData.append(key,items[k]);  // another way to append data in format
      //   }
      formatData.append("title", this.form.title);
      formatData.append("desc", this.form.desc);
      this.imgsFiles
        ? this.imgsFiles.forEach(el => {
            formatData.append("photos[]", el);
          })
        : "";
      this.form.tagesIds
        ? this.form.tagesIds.forEach(el => {
            formatData.append("tags[]", el);
          })
        : "";

      !this.isUpdated &&
        this.form.vedios.forEach(el => {
          formatData.append("videos[]", el);
        });

      this.isUpdated &&
        this.updatedData.vedios.forEach(el => {
          formatData.append("videos[]", el);
        });

      formatData.append("publisher", this.form.publisher);

      this.form.imgValue
        ? formatData.append("main_photo", this.form.imgValue)
        : "";

      formatData.append("locale", this.locale);
      this.isUpdated ? formatData.append("_method", "put") : "";

      formatData.append(
        "source",
        this.form.source == null ? "" : this.form.source
      );

      formatData.append(
        "source_url",
        this.form.source_url == null ? "" : this.form.source_url
      );

      return formatData;
    },
    showNews(slug, locale) {
      //   this.loader = true;
      showNews(slug, locale)
        .then(res => {
          //   this.loader = false;
          const { news } = res.data;
          const {
            title,
            desc,
            main_photo,
            media,
            source,
            source_url,
            publisher,
            tags
          } = news;
          const photos = [];
          const vedios = [];
          this.main_photo = main_photo;
          this.form.title = title;
          this.form.desc = desc;
          this.form.source = source;
          this.form.source_url = source_url;
          this.form.publisher = publisher == null ? "" : publisher;
          this.form.tagesIds = tags.map(el => el.id);
          this.ShowImgs = photos;
          this.form.vedios = vedios;
          media.map(el => {
            if (el.type == "photo" && !el.main) {
              this.photosMedia.push(el);
              if (photos.includes(el.path)) {
                return;
              }
              photos.push(el.path);
            } else if (el.type == "video") {
              this.videosMedia.push(el);
              if (vedios.includes(el.path)) {
                return;
              }
              vedios.push(el.path);
            }
          });

          this.imgPath = main_photo.path;
        })
        .catch(() => {});
    },
    getImgValue(dataobj) {
      this.change = false;
      this.form.imgValue = dataobj.file;
      this.imgErorr = false;
    },
    handleActive() {
      this.change = false;
    },
    convertVedio(vedio) {
      let url;
      let key;
      var regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i;
      key = vedio.match(regex)[1];
      url = vedio.substring(0, 24) + "embed/" + key;
      return url;
    },
    dissabledButton() {
      if (!this.isUpdated) {
        return (
          this.$v.form.$invalid ||
          this.imgErorr ||
          !this.form.imgValue ||
          this.change
        );
      } else {
        return this.$v.$anyError || this.change;
      }
    },
    deleteIamge(e, index, imgs) {
      this.change = false;

      let key = this.imgsFiles[this.imgsFiles.length];

      const { id, main } = this.photosMedia[index]
        ? this.photosMedia[index]
        : {};
      if (id !== undefined) {
        this.popUp().then(value => {
          if (!value.dismiss) {
            if (main) {
              alert("you cant delete main photo");
            } else {
              deleteMedia(id)
                .then(() => {
                  imgs.splice(index, 1);
                  this.imgsFiles.splice(key, 1);
                })
                .catch(() => {});
            }
          }
        });
      } else {
        imgs.splice(index, 1);
        this.imgsFiles.splice(key, 1);
      }
    },
    deleteVidoe(e, index, vidoes) {
      this.change = false;
      //   vidoes.splice(index, 1);

      const { id } = this.videosMedia[index] ? this.videosMedia[index] : {};
      if (id !== undefined) {
        this.popUp().then(value => {
          if (!value.dismiss) {
            deleteMedia(id)
              .then(() => {
                vidoes.splice(index, 1);
              })
              .catch(() => {});
          }
        });
      } else {
        vidoes.splice(index, 1);
        // this.imgsFiles.splice(index, 1);
      }
    },
    validationsRules() {
      return {
        form: {
          title: {
            required,
            maxLength: maxLength(200),
            minLength: minLength(3)
          },
          desc: {
            required,
            maxWords: maxWords(500),
            minLength: minLength(50)
          },
          publisher: {
            maxLength: maxLength(30),
            minLength: minLength(3)
          },
          source: {
            required: requiredIf(nasted => {
              return nasted.source_url !== null && nasted.source_url !== "";
            })
          },
          vedio: { url },
          source_url: {
            required: requiredIf(nasted => {
              return nasted.source !== null && nasted.source !== "";
            }),
            url
          }
        }
      };
    },
    onFileChange(e) {
      this.change = false;
      let imgFiles = e.target.files;

      for (let i = 0; i < imgFiles.length; i++) {
        const fileReader = new FileReader(); // important

        this.imgsFiles.push(imgFiles[i]);

        if (this.validateType(imgFiles[i])) {
          if (this.validateSize(imgFiles[i])) {
            fileReader.addEventListener("load", () => {
              this.ShowImgs.push(fileReader.result);
            });
          }
        }

        fileReader.readAsDataURL(imgFiles[i]);
      }
    },
    validateType(file) {
      if (/\.(jpe?g|png)$/i.test(file.name)) {
        return true;
      } else {
        this.errorDialog = true;
        this.errorText = `type must be jpg or png `;
        return false;
      }
    },
    validateSize(file) {
      const convertSize = file.size / 1024;
      if (convertSize > this.photoSize) {
        this.errorDialog = true;
        this.errorText = `size must be less than 1mp `;
        return false;
      } else {
        return true;
      }
    },
    addVedios() {
      this.updatedData.vedios.push(this.form.vedio);
      if (this.form.vedio !== "") {
        if (this.form.vedios.includes(this.form.vedio)) {
          return;
        }
        this.form.vedios.push(this.form.vedio);
        this.form.vedio = "";
      }
    },
    backToNews() {
      this.$router.push("/news/list");
    }
  },
  watch: {
    locale: {
      handler() {},
      immediate: true
    },
    $route: {
      handler(route) {
        if (route.query.slug) {
          this.isUpdated = true;
        } else {
          this.isUpdated = false;
        }
      },
      immediate: true
    },
    ShowImgs: {
      handler(val) {
        if (val.length === 0) {
          this.imgsFiles = [];
        }
      },
      immediate: true
    }
  }
};
</script>

<style scoped>
.img_wrpper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  position: relative;
}

.input_wrpper {
  position: relative;
}

.input_wrpper .btn {
  position: absolute;
  right: -10px;
  top: 3px;
}
.img_error {
  color: red;
}
.img_pointer,
.video_pointer {
  position: relative;
}
.img_pointer:hover .close_icon {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.video_pointer:hover .close_icon {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}
.close_icon {
  width: 1.2em;
  height: 1.2em;
  background: red;
  font-size: 18px !important;
  border-radius: 50%;
  position: absolute;
  top: -12px;
  transition: all 0.2s ease;
  transform: translateY(15px);
  opacity: 0;
  visibility: hidden;
}

.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.5s;
}
.fadeIn-enter,
.fadeIn-leave-to {
  opacity: 0;
}
.place_pos {
  position: absolute;
}
</style>
